// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  background: #f3f3f3 !important;
}

.btn-primary {
  background-color: #3cb599 !important;
}

.btn-secondary {
  color: #fff;
  background-color: grey !important;
}

a {
  color: #3cb599 !important;
}

.grey {
  background-color: gray !important;
  color: #fff;
}

.green {
  background-color: #3cb599 !important;
  color: #fff;
}

.padding-0 {
  padding: 0 !important;
}

.primary-color {
  color: #3cb599 !important;
}

.form-check-input:checked {
  background-color: #3cb599 !important;
  border-color: #3cb599 !important;
}

.center {
  text-align: center;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.large-input {
  max-width: 400px !important;
}

.medium-input {
  max-width: 200px !important;
}

.town-input {
  max-width: 230px !important;
}

.small-input {
  max-width: 100px !important;
}

.tiny-input {
  width: 125px !important;
}

.code-postal-input {
  width: 105px !important;
}

.no-pl {
  padding-left: 0 !important;
}

.navbar-brand a {
  color: white !important;
  font-weight: bold;
  font-size: 24px;
}

.navbar-light.navbar.navbar-expand-lg.bg-light.navbar-color {
  padding: 20px;
  background-color: #2d323e !important;
}

.navbar-light .navbar-nav .nav-link {
  color: white !important;
  font-weight: bold;
  font-size: 18px;
}

.react-tooltip {
  z-index: 1050;
}

.py-10 {
  padding-top: 9rem !important;
  padding-bottom: 3rem !important;
}

.p-20 {
  padding: 20px;
}
.ml-20 {
  margin-left: 20px !important;
}
.pl-20 {
  padding-left: 20px !important;
}
.pb-50 {
  padding-bottom: 45px !important;
}
.pl-30 {
  padding-left: 35px !important;
}
.ml-40 {
  margin-left: 40px !important;
}
.ml-10 {
  margin-left: 10px !important;
}
.input-label {
  font-size: 12px;
  font-weight: normal;
}
.mr-10 {
  margin-right: 10px !important;
}
.mt-20 {
  margin-top: 20px !important;
}
.mt-25 {
  margin-top: 25px !important;
}

.mt-40 {
  margin-top: 40px !important;
}

.mt-10 {
  margin-top: 10px !important;
}
.mt-50 {
  margin-top: 50px !important;
}
.mt-0 {
  margin-top: 0 !important;
}
.ml-0 {
  margin-left: 0 !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.mt-6 {
  margin-top: 6px !important;
}
.mb-15 {
  margin-bottom: 15px !important;
}
.mb-25 {
  margin-bottom: 25px !important;
}
.mt-15 {
  margin-top: 15px !important;
}
.pt-10 {
  padding-top: 10px !important;
}
.pl-10 {
  padding-left: 10px !important;
}

.pl-25 {
  padding-left: 25px !important;
}

.pt-20 {
  padding-top: 20px !important;
}

.nav-link {
  cursor: pointer;
}

.bold {
  font-weight: bold;
}

.italic {
  font-style: italic;
}

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .nav-link.active {
  color: white !important;
}

.navbar-light .navbar-toggler {
  color: white !important;
}

.left {
  text-align: left;
}
.right {
  text-align: right;
}

.mr-0 {
  margin-right: 0 !important;
  width: 100%;
}

.mr-25 {
  margin-right: 25px !important;
}

.full-width {
  width: fit-content;
}

.vh-875 {
  padding-top: 10px;
  margin-top: 25px;
}

.form-outline .form-control {
  border: 1px solid gray !important;
}

.navbar {
  padding: 20px;
}

.pagetitle {
  font-weight: 100;
  font-size: 24px;
  text-align: left;
}

.btn,
.modal,
.modal-content,
.form-control,
.form-select {
  border-radius: 0 !important;
}

.no-padding {
  padding: 0 !important;
}

.xs-hidden {
  display: block;
}

/*Smartphones (portrait and landscape)*/
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  /* Styles pour cette Media Queries */
  .card {
    margin-bottom: 10px;
  }
  .RFS-Label {
    display: none !important;
  }

  .xs-hidden {
    display: none;
  }

  .RFS-StepperContainer {
    padding-left: 0 !important;
  }

  .step-body {
    margin-left: 0 !important;
  }

  .step-title {
    padding-left: 0 !important;
  }
  .card-body {
    padding: 10px !important;
  }
}

/*Smartphones (portrait)*/
@media only screen and (max-width: 320px) {
  /* Styles pour cette Media Queries */
  .card {
    margin-bottom: 5px;
  }
}

.project-card {
  min-height: 150px;
}

.pointer {
  cursor: pointer;
}

.small {
  font-size: 11px !important;
}

.badge.bg-primary {
  background-color: #3cb599 !important;
}

.card {
  border-radius: 0 !important;
}

.nav-tabs .nav-link {
  padding: 17px 19px 16px 19px !important;
}

.link {
  cursor: pointer;
  color: #3cb599;
  text-decoration: underline;
  font-weight: bold;
}

.react-toggle--checked .react-toggle-track {
  background-color: #3cb599;
}
.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
  background-color: #3cb599;
}

.container .jumbotron,
.container-fluid .jumbotron {
  padding-right: 15px;
  padding-left: 15px;
  border-radius: 6px;
}
.jumbotron {
  padding-top: 30px;
  padding-bottom: 30px;
  margin-bottom: 30px;
  color: inherit;
  background-color: #eee;
}

.property-label {
  margin-top: 10px;
  font-weight: bold;
}

.active.flipping-tab.nav-link {
  border-bottom: 3px solid #3cb599 !important;
}

.nav-tabs .nav-link:hover {
  border-bottom: 3px solid darkgray !important;
}

.step-counter:after {
  font-size: 50%;
  vertical-align: top;
}

.support-link {
  font-size: 14px;
}

.dropdown-toggle::after {
  display: none !important;
}

.dropdown-menu > li {
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;EACjD,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,oCAAoC;EACpC;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;EACpC;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf","sourcesContent":["body {\n  font-family: Roboto, Helvetica, Arial, sans-serif;\n  background: #f3f3f3 !important;\n}\n\n.btn-primary {\n  background-color: #3cb599 !important;\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: grey !important;\n}\n\na {\n  color: #3cb599 !important;\n}\n\n.grey {\n  background-color: gray !important;\n  color: #fff;\n}\n\n.green {\n  background-color: #3cb599 !important;\n  color: #fff;\n}\n\n.padding-0 {\n  padding: 0 !important;\n}\n\n.primary-color {\n  color: #3cb599 !important;\n}\n\n.form-check-input:checked {\n  background-color: #3cb599 !important;\n  border-color: #3cb599 !important;\n}\n\n.center {\n  text-align: center;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.large-input {\n  max-width: 400px !important;\n}\n\n.medium-input {\n  max-width: 200px !important;\n}\n\n.town-input {\n  max-width: 230px !important;\n}\n\n.small-input {\n  max-width: 100px !important;\n}\n\n.tiny-input {\n  width: 125px !important;\n}\n\n.code-postal-input {\n  width: 105px !important;\n}\n\n.no-pl {\n  padding-left: 0 !important;\n}\n\n.navbar-brand a {\n  color: white !important;\n  font-weight: bold;\n  font-size: 24px;\n}\n\n.navbar-light.navbar.navbar-expand-lg.bg-light.navbar-color {\n  padding: 20px;\n  background-color: #2d323e !important;\n}\n\n.navbar-light .navbar-nav .nav-link {\n  color: white !important;\n  font-weight: bold;\n  font-size: 18px;\n}\n\n.react-tooltip {\n  z-index: 1050;\n}\n\n.py-10 {\n  padding-top: 9rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.p-20 {\n  padding: 20px;\n}\n.ml-20 {\n  margin-left: 20px !important;\n}\n.pl-20 {\n  padding-left: 20px !important;\n}\n.pb-50 {\n  padding-bottom: 45px !important;\n}\n.pl-30 {\n  padding-left: 35px !important;\n}\n.ml-40 {\n  margin-left: 40px !important;\n}\n.ml-10 {\n  margin-left: 10px !important;\n}\n.input-label {\n  font-size: 12px;\n  font-weight: normal;\n}\n.mr-10 {\n  margin-right: 10px !important;\n}\n.mt-20 {\n  margin-top: 20px !important;\n}\n.mt-25 {\n  margin-top: 25px !important;\n}\n\n.mt-40 {\n  margin-top: 40px !important;\n}\n\n.mt-10 {\n  margin-top: 10px !important;\n}\n.mt-50 {\n  margin-top: 50px !important;\n}\n.mt-0 {\n  margin-top: 0 !important;\n}\n.ml-0 {\n  margin-left: 0 !important;\n}\n.pl-0 {\n  padding-left: 0 !important;\n}\n.mt-6 {\n  margin-top: 6px !important;\n}\n.mb-15 {\n  margin-bottom: 15px !important;\n}\n.mb-25 {\n  margin-bottom: 25px !important;\n}\n.mt-15 {\n  margin-top: 15px !important;\n}\n.pt-10 {\n  padding-top: 10px !important;\n}\n.pl-10 {\n  padding-left: 10px !important;\n}\n\n.pl-25 {\n  padding-left: 25px !important;\n}\n\n.pt-20 {\n  padding-top: 20px !important;\n}\n\n.nav-link {\n  cursor: pointer;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.italic {\n  font-style: italic;\n}\n\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .nav-link.active {\n  color: white !important;\n}\n\n.navbar-light .navbar-toggler {\n  color: white !important;\n}\n\n.left {\n  text-align: left;\n}\n.right {\n  text-align: right;\n}\n\n.mr-0 {\n  margin-right: 0 !important;\n  width: 100%;\n}\n\n.mr-25 {\n  margin-right: 25px !important;\n}\n\n.full-width {\n  width: fit-content;\n}\n\n.vh-875 {\n  padding-top: 10px;\n  margin-top: 25px;\n}\n\n.form-outline .form-control {\n  border: 1px solid gray !important;\n}\n\n.navbar {\n  padding: 20px;\n}\n\n.pagetitle {\n  font-weight: 100;\n  font-size: 24px;\n  text-align: left;\n}\n\n.btn,\n.modal,\n.modal-content,\n.form-control,\n.form-select {\n  border-radius: 0 !important;\n}\n\n.no-padding {\n  padding: 0 !important;\n}\n\n.xs-hidden {\n  display: block;\n}\n\n/*Smartphones (portrait and landscape)*/\n@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {\n  /* Styles pour cette Media Queries */\n  .card {\n    margin-bottom: 10px;\n  }\n  .RFS-Label {\n    display: none !important;\n  }\n\n  .xs-hidden {\n    display: none;\n  }\n\n  .RFS-StepperContainer {\n    padding-left: 0 !important;\n  }\n\n  .step-body {\n    margin-left: 0 !important;\n  }\n\n  .step-title {\n    padding-left: 0 !important;\n  }\n  .card-body {\n    padding: 10px !important;\n  }\n}\n\n/*Smartphones (portrait)*/\n@media only screen and (max-width: 320px) {\n  /* Styles pour cette Media Queries */\n  .card {\n    margin-bottom: 5px;\n  }\n}\n\n.project-card {\n  min-height: 150px;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.small {\n  font-size: 11px !important;\n}\n\n.badge.bg-primary {\n  background-color: #3cb599 !important;\n}\n\n.card {\n  border-radius: 0 !important;\n}\n\n.nav-tabs .nav-link {\n  padding: 17px 19px 16px 19px !important;\n}\n\n.link {\n  cursor: pointer;\n  color: #3cb599;\n  text-decoration: underline;\n  font-weight: bold;\n}\n\n.react-toggle--checked .react-toggle-track {\n  background-color: #3cb599;\n}\n.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {\n  background-color: #3cb599;\n}\n\n.container .jumbotron,\n.container-fluid .jumbotron {\n  padding-right: 15px;\n  padding-left: 15px;\n  border-radius: 6px;\n}\n.jumbotron {\n  padding-top: 30px;\n  padding-bottom: 30px;\n  margin-bottom: 30px;\n  color: inherit;\n  background-color: #eee;\n}\n\n.property-label {\n  margin-top: 10px;\n  font-weight: bold;\n}\n\n.active.flipping-tab.nav-link {\n  border-bottom: 3px solid #3cb599 !important;\n}\n\n.nav-tabs .nav-link:hover {\n  border-bottom: 3px solid darkgray !important;\n}\n\n.step-counter:after {\n  font-size: 50%;\n  vertical-align: top;\n}\n\n.support-link {\n  font-size: 14px;\n}\n\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.dropdown-menu > li {\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
